import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import "styles/form.css";
import { BANK_STATEMENT_MANNUAL_FINNOV_ANALYSIS_FORM } from "constants/form-fields";
const FormItem = Form.Item;
class BankStatementMannualForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        product_list: [],
        showForm: false
    };

    uploadDocuments = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            this.props.onSubmit(values);
        });
    }

    render() {
        return (
            <div className={"p-10"}>
                <Form
                    className={cx("form", "br-3")}
                >
                    <div className={"form-row"}>
                        {BANK_STATEMENT_MANNUAL_FINNOV_ANALYSIS_FORM.map((field, fieldName) => {
                            if(fieldName === "account_type") {
                                field.options = this.props.analysisTypeList && this.props.analysisTypeList.map((_, k) => ({
                                    label: k,
                                    value: _
                                })).toList().toArray();
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className="d-flex justify-content-flex-end">
                        <FormItem className={cx("mr-5")}>
                            <Button key="save" type="primary" icon={"plus"} onClick={this.uploadDocuments}>{"Save"}</Button>
                        </FormItem>
                    </div>
                </Form>
            </div>
        );
    }
}

BankStatementMannualForm.propTypes = {
    form: PropTypes.object,
    banks: PropTypes.array,
    onSubmit: PropTypes.func,
    analysisTypeList: PropTypes.object
};

export default Form.create({})(BankStatementMannualForm);